export enum EPaymentType {
	PAY_NOW = 'full',
	PAY_LATER = 'advance',
}

export enum EPaymentMethod {
	ONLINE = 160,
	BLIK = 150,
	APPLE_PAY = 170,
	GOOGLE_PAY = 166,
}
